{
  
  
  "refinance": "Refinance",
  "construction": "Construction",
  
  "standard": "Standard",
  "custom": "Custom",
  
  "buyer": "Buyer",
  "seller": "Seller",
  "lender": "Lender",
  "borrower": "Borrower",
  "attorney": "Attorney",
  "title_agent": "Title Agent",
  "payee": "Payee",
  
  "mortgage": "Mortgage",
  "disclosure": "Disclosure",
  "survey": "Survey",
  
  "loan_amount": "Loan Amount",
  "down_payment": "Down Payment",
  "earnest_money": "Earnest Money",
  "commission": "Commission",
  
  "active": "Active",
  "pending": "Pending",
  "on_hold": "On Hold",
  
  "wire": "Wire Transfer",
  "check": "Check",
  "cash": "Cash"
}
